import { useEffect } from 'react'
import { siteUrl } from '../lib/site'

interface SeoProps {
  title: string
  description: string
  /** 相对路径，如 "/"、"/records" */
  path?: string
  noIndex?: boolean
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setLink(rel: string, href: string, hreflang?: string) {
  const selector = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`
  let el = document.head.querySelector<HTMLLinkElement>(selector)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    if (hreflang) el.setAttribute('hreflang', hreflang)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

/** 每页 SEO：title / description / og / twitter / canonical / hreflang（中英 ?lang= 变体） */
export function Seo({ title, description, path = '/', noIndex = false }: SeoProps) {
  useEffect(() => {
    const url = siteUrl(path)
    document.title = title
    setMeta('name', 'description', description)
    setMeta('name', 'robots', noIndex ? 'noindex,nofollow' : 'index,follow')

    setMeta('property', 'og:title', title)
    setMeta('property', 'og:description', description)
    setMeta('property', 'og:url', url)
    setMeta('name', 'twitter:title', title)
    setMeta('name', 'twitter:description', description)

    setLink('canonical', url)
    setLink('alternate', siteUrl(path === '/' ? '/?lang=zh' : `${path}?lang=zh`), 'zh')
    setLink('alternate', siteUrl(path === '/' ? '/?lang=en' : `${path}?lang=en`), 'en')
    setLink('alternate', url, 'x-default')
  }, [title, description, path, noIndex])

  return null
}
